export default __webpack_public_path__ + "static/media/3VA27.124f37ff.jpg";